// Region key -> display name for one alg version's vectorTypes, as returned by
// /algVersions/vectorTypes. Flattened across vector types since region keys are
// unique across mosquito and tick. The "<vectorType>: all" entry is the
// selector's label for the whole model family, not a region name, so it is
// left out.
const flattenRegionNames = (vectorTypes) =>
  Object.values(vectorTypes || {}).reduce((names, regions) => {
    if (regions && typeof regions === "object" && !Array.isArray(regions)) {
      Object.entries(regions).forEach(([region, name]) => {
        if (name && name !== "all") {
          names[region] = name;
        }
      });
    }
    return names;
  }, {});

// Raw data rows carry the region the alg service recorded, which is the
// region key (e.g. a uuid) whenever the manifest had no display name for it at
// capture. Resolve it the way the Region selector does - the row's own alg
// version first, then the latest - and keep the value as-is when neither
// knows it.
export const withRegionDisplayNames = (rows, algVersions) => {
  if (!Array.isArray(rows)) {
    return rows;
  }
  const latest = flattenRegionNames(algVersions?.vectorTypes);
  const byVersion = {};
  return rows.map((row) => {
    const region = row?.algRegionName;
    if (!region) {
      return row;
    }
    const version = row.algVersion;
    if (version && !(version in byVersion)) {
      byVersion[version] = flattenRegionNames(algVersions?.[version]);
    }
    const name = byVersion[version]?.[region] || latest[region];
    return name && name !== region ? { ...row, algRegionName: name } : row;
  });
};
